const studyManage = () => import('./study/studyManage');
const projectManage = () => import('./project/projectManage');

const courseAuthorConfig = () => import('./courseAuthorConfig');
const courseClassificationManagement = () =>
  import('./courseClassificationManagement');
const courseResourceManagement = () => import('./courseResourceManagement');

const Router = [
  {
    path: 'audioAndVideoCourses',
    name: 'studyManage',
    component: studyManage,
    meta: {
      title: '音视频课程',
    },
  },
  {
    path: 'studyPracticeTestCourse',
    name: 'studyManage',
    component: studyManage,
    meta: {
      title: '学练测课程',
    },
  },

  {
    path: 'studyManage',
    name: 'studyManage',
    component: studyManage,
    meta: {
      title: '学练测课程',
    },
  },
  {
    path: 'projectbasedCourse',
    name: 'projectManage',
    component: projectManage,
    meta: {
      title: '项目式课程',
    },
  },
  {
    path: 'projectManage',
    name: 'projectManage',
    component: projectManage,
    meta: {
      title: '项目式课程',
    },
  },
  {
    path: 'courseAuthorConfig',
    name: 'courseAuthorConfig',
    component: courseAuthorConfig,
    meta: {
      title: '注册用户',
    },
  },
  {
    path: 'courseClassificationManagement',
    name: 'courseClassificationManagement',
    component: courseClassificationManagement,
    meta: {
      title: '课程分类管理',
    },
  },
  {
    path: 'courseResourceManagement',
    name: 'courseResourceManagement',
    component: courseResourceManagement,
    meta: {
      title: '数字课程管理',
    },
  },
];
export default Router;
